import { type Directive, nextTick } from 'vue'

export const AutoFocus: Directive<HTMLElement> = {
  async mounted(el, binding) {
    if (binding.value !== false) {
      await nextTick(() => {
        const node = el.querySelector('input') ?? el
        node.focus()
      })
    }
  },
}
